import dayjs from "dayjs";

/**
 * 공휴일/휴무일 목록
 * 날짜별로 타이틀과 메시지를 커스터마이징할 수 있습니다.
 *
 * 사용법:
 * - date: YYYY-MM-DD 형식의 날짜
 * - title: 팝업 타이틀
 * - message: 팝업 메시지 (\n으로 줄바꿈 가능)
 */
export const HOLIDAYS = [
  // 개발/로컬 환경 테스트용 (12/24) - PROD에서는 제외
  ...(import.meta.env.VITE_APP_PHASE !== "PROD"
    ? [
        {
          date: "2025-12-24",
          title: "콜센터는 오늘 하루만 쉬어갑니다",
          message: "지구하다 플랫폼 서비스는\n정상 운영으로 이용 가능합니다.",
        },
      ]
    : []),
  // 2025년
  {
    date: "2025-12-25",
    title: "콜센터는 오늘 하루만 쉬어갑니다",
    message: "지구하다 플랫폼 서비스는\n정상 운영으로 이용 가능합니다.",
  },
  // 2026년
  {
    date: "2026-01-01",
    title: "콜센터는 오늘 하루만 쉬어갑니다",
    message: "지구하다 플랫폼 서비스는\n정상 운영으로 이용 가능합니다.",
  },
  {
    date: "2026-02-16",
    title: "콜센터는 설날 연휴에는 쉬어갑니다",
    message: "지구하다 플랫폼 서비스는\n정상 운영으로 이용 가능합니다.",
  },
  {
    date: "2026-02-17",
    title: "콜센터는 설날 연휴에는 쉬어갑니다",
    message: "지구하다 플랫폼 서비스는\n정상 운영으로 이용 가능합니다.",
  },
  {
    date: "2026-02-18",
    title: "콜센터는 설날 연휴에는 쉬어갑니다",
    message: "지구하다 플랫폼 서비스는\n정상 운영으로 이용 가능합니다.",
  },
  {
    date: "2026-03-02",
    title: "콜센터는 대체공휴일로 쉬어갑니다",
    message: "지구하다 플랫폼 서비스는\n정상 운영으로 이용 가능합니다.",
  },
  {
    date: "2026-09-24",
    title: "콜센터는 추석 연휴에는 쉬어갑니다",
    message: "지구하다 플랫폼 서비스는\n정상 운영으로 이용 가능합니다.",
  },
  {
    date: "2026-09-25",
    title: "콜센터는 추석 연휴에는 쉬어갑니다",
    message: "지구하다 플랫폼 서비스는\n정상 운영으로 이용 가능합니다.",
  },
  {
    date: "2026-09-26",
    title: "콜센터는 추석 연휴에는 쉬어갑니다",
    message: "지구하다 플랫폼 서비스는\n정상 운영으로 이용 가능합니다.",
  },
  {
    date: "2026-09-28",
    title: "콜센터는 대체공휴일로 쉬어갑니다",
    message: "지구하다 플랫폼 서비스는\n정상 운영으로 이용 가능합니다.",
  },
];

/**
 * 오늘이 공휴일인지 확인하고 해당 정보를 반환합니다.
 * @param {dayjs.Dayjs} date - 확인할 날짜 (기본값: 오늘)
 * @returns {{ isHoliday: boolean, title?: string, message?: string }}
 */
export const getHolidayInfo = (date = dayjs()) => {
  const dateStr = date.format("YYYY-MM-DD");
  const holiday = HOLIDAYS.find((h) => h.date === dateStr);

  if (holiday) {
    return {
      isHoliday: true,
      title: holiday.title,
      message: holiday.message,
    };
  }
  return { isHoliday: false };
};
